// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oreM","colMin":"styles_colMin__2ijNe"};